import { createRouter, FileRoutesByPath, Router } from '@tanstack/react-router';

import type { RouterContext } from '@mint-lib/routing-context';

import { NotFound } from './components/NotFound.jsx';
import { context } from './context/router-context.js';
// @ts-ignore TS6307 Does not include this file
import { routeTree } from './routeTree.gen.js';

export * from '@tanstack/react-router';

export const routerContext = context;
export type MintRouter = Router<typeof routeTree, 'preserve', boolean>;

// Create a new router instance
const routerInstance = createRouter({
  routeTree,
  context,
  defaultNotFoundComponent: NotFound,
  trailingSlash: 'preserve',
});

export { routerInstance };

export type AllRoutesByPath = keyof FileRoutesByPath;

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof routerInstance;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface RouteContext extends RouterContext {}
}
